module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_PhotosetEvent Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_PhotosetEvent', {

		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				template: 'activity_event_card_photoset'
			});

			fox.registerTemplateModifier('isWide', function (obj) {
							if (fox.isEmpty(obj)) return;
				var w = parseInt(obj.width);
				var h = parseInt(obj.height);

				return (w / h > .84); 
			});
			
			this.callParent('configure', arguments);
		},

		init: function () {
			this.p = this.getParent();
		
			this.callParent('init', arguments);
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/activity/event/photosetEvent.js
// module id = 825
// module chunks = 4